import { render, staticRenderFns } from "./SetManagement.vue?vue&type=template&id=52d4fb1a&scoped=true"
import script from "./SetManagement.vue?vue&type=script&lang=js"
export * from "./SetManagement.vue?vue&type=script&lang=js"
import style0 from "./SetManagement.vue?vue&type=style&index=0&id=52d4fb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4fb1a",
  null
  
)

export default component.exports